import React from 'react'
import { getDateFromIso } from '@App/helpers/get-date-iso-6801'

interface WorkItemDatesInfoProps {
    updateDate?: string | null
    historyType?: boolean
    sourceName?: string | null
    rightsholderProprietaryId?: string | null
}

const WorkItemDatesInfo = ({
    updateDate,
    historyType,
    sourceName,
    rightsholderProprietaryId,
}: WorkItemDatesInfoProps) => (
    <>
        {updateDate && (
            <p className="small-2">
                <span>{historyType ? 'Submitted ' : ''}Date:&nbsp;</span>
                <span className="bold">{getDateFromIso(updateDate)}</span>
            </p>
        )}
        {sourceName && (
            <p className="small-2">
                <span>Submission Source:&nbsp;</span>
                <span className="bold">{sourceName}</span>
            </p>
        )}
        {rightsholderProprietaryId && (
            <p className="small-2">
                <span>Member&apos;s Song ID:{'\u00a0'}</span>
                <span className="bold">{rightsholderProprietaryId}</span>
            </p>
        )}
    </>
)

export default WorkItemDatesInfo
